<template>
  <v-navigation-drawer
    v-model="enable"
    absolute
    temporary
    color="topBar"
    dark
    class="side-bar"
  >
    <div class="py-2 px-5">
      <logged-in-user />
    </div>
    <v-divider />
    <v-list>
      <div
        v-for="item in items"
        :key="`navigation-item-${item.title}`"
      >
        <v-list-group
          v-if="item.subItems.length"
          :value="true"
          :prepend-icon="item.icon"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </template>

          <v-list-item
            v-for="subItem in item.subItems"
            :key="`navigation-item-subItem--${subItem.title}`"
            router-link
            :to="subItem.path" 
          >
            <v-list-item-icon>
              <v-icon>{{ subItem.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ subItem.title }}</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-item
          v-else
          slot="activator"
          active-class="active"
          router-link
          :to="item.path"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </div>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import LoggedInUser from "./LoggedInUser.vue";
export default {
  name: "SideNavigationBar",
  components: {
    LoggedInUser
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      items: [
        {
          path: "/apps",
          title: "Apps",
          icon: "mdi-apps",
          link: "apps",
          subItems: []
        },
        {
          path: "/posServers",
          title: "Pos servers",
          icon: "mdi-laptop",
          link: "posServers",
          subItems: []
        },
        {
          path: "/pos",
          title: "Pos",
          icon: "mdi-table-chair",
          link: "pos",
          subItems: [
            { title: "Corporate", path: "/corporate", icon: "mdi-bank" },
            { title: "Accounts", path: "/accounts", icon: "mdi-view-list" },
            { title: "Stores", path: "/stores", icon: "mdi-store" },
            { title: "Login Migration", path: "/sso/migration", icon: "mdi-account-sync" }
          ]
        },
        {
          path: "/eventAccounts",
          title: "Evm Accounts",
          icon: "mdi-calendar",
          link: "event",
          subItems: []
        },
        {
          path: "/inventory",
          title: "Inventory",
          icon: "mdi-package-variant",
          link: "inventory",
          subItems: []
        },
        {
          path: "/user",
          title: "Users",
          icon: "mdi-account-box",
          link: "user",
          subItems: [
            { title: "User", path: "/users", icon: "mdi-account-box" },
            { title: "Roles", path: "/roles", icon: "mdi-account-box" }
          ]
        }
      ]
    };
  },
  computed: {
    enable: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      }
    }
  }
};
</script>

<style lang="scss">
.side-bar {
  background: radial-gradient(black, transparent);
}
</style>